<button #trigger="tranDropdownTrigger" tranDropdownTrigger class="dropdown-toggle flex gap-2">
    <tran-application-status-indicator [status]="control.value!" />
    <i aria-hidden="true" class="m-0 dropdown-caret icon element-down-2"></i>
</button>

<tran-dropdown
    [trigger]="trigger"
    [selectedValue]="control.value!"
    [values]="possibleStatusSelectionsInOrder"
    labelPrefix="applications.status"
    (valueSelected)="selectStatus($event)"
/>
